import React, { Component } from 'react'
import { Chart } from 'chart.js/auto';
import classes from "./Graph.module.css";
import 'chartjs-adapter-moment';
import zoomPlugin from 'chartjs-plugin-zoom';
import annotationPlugin from 'chartjs-plugin-annotation';
import GraphZoomControls from './GraphZoomControls.js';

Chart.register(zoomPlugin);
Chart.register(annotationPlugin);

// Snap the X span to whole days so the left-edge tick lands on the daily date
// grid. Otherwise Chart.js draws an extra tick at the exact min (an arbitrary
// clock time), which collides with the first grid date (e.g. "31/05" jammed
// against "01/06") at the start of the axis.
const snapMinToDayStart = (ts) => { let d = new Date(ts); d.setHours(0, 0, 0, 0); return d.getTime(); };
const snapMaxToDayEnd = (ts) => {
    let d = new Date(ts); d.setHours(0, 0, 0, 0);
    return d.getTime() === ts ? ts : d.getTime() + 24 * 3600000;
};

class GraphOneBar extends Component {
    constructor(props){
        super(props);
        this.myChart = "";
    }

    generateAnnotationsList(annotations, alertPoints, alertPointsReminder, min) {
        if (this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) {
            alertPoints.forEach((e, i) => {
                let new_point = {
                    type: 'point',
                    backgroundColor: 'transparent',
                    borderColor: 'red',
                    borderWidth: 1,
                    pointStyle: 'triangle',
                    radius: 8,
                    xValue: e.x,
                    yValue: e.y,
                    yScaleID: 'y'
                }
                let new_label = {
                    type: 'label',
                    color: 'red',
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    content: (ctx) => 'Alert',
                    font: {
                        size: 10
                    },
                    xValue: e.x,
                    yValue: e.y,
                    yScaleID: 'y'
                }
                annotations["alertPoints_" + i] = new_point
                annotations["alertLabel_" + i] = new_label
            })
        }
        if (alertPointsReminder !== undefined && alertPointsReminder.length > 0) {
            alertPointsReminder.forEach((e, i) => {
                let eventTime = new Date(e.x)
                eventTime.setHours(0)
                eventTime.setMinutes(0)
                eventTime.setSeconds(0)
                let new_point = {
                    type: 'point',
                    backgroundColor: 'transparent',
                    borderColor: 'red',
                    borderWidth: 1,
                    pointStyle: 'crossRot',
                    radius: 8,
                    yAdjust: -6,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                    yScaleID: 'y'
                }
                let new_label = {
                    type: 'label',
                    color: 'red',
                    position: {
                        x: 'center',
                        y: 'end'
                    },
                    content: (ctx) => '?',
                    font: {
                        size: 10
                    },
                    yAdjust: -3,
                    xValue: eventTime.toISOString(),
                    yValue: min,
                    yScaleID: 'y'
                }
                annotations["alertPoints_reminder_" + i] = new_point
                annotations["alertLabel_reminder_" + i] = new_label
            })
        }
        return (annotations)
    }


    addMedianAnnotation(annotations) {
        if (this.props.medianLine !== undefined && this.props.medianLine !== null && !Number.isNaN(this.props.medianLine)) {
            annotations["medianLine"] = {
                type: 'line',
                yMin: this.props.medianLine,
                yMax: this.props.medianLine,
                borderColor: 'red',
                borderWidth: 2,
                hitTolerance: 6,
                yScaleID: 'y',
                label: {
                    display: false,
                    content: this.props.medianLineLabel,
                    position: 'center',
                    backgroundColor: 'rgba(0,0,0,0.8)',
                    color: 'white',
                    font: {size: 11}
                },
                // Show the label only while hovering the line, returning true re-renders the chart
                enter(ctx) {
                    ctx.element.label.options.display = true
                    return true
                },
                leave(ctx) {
                    ctx.element.label.options.display = false
                    return true
                }
            }
        }
        return annotations
    }

    componentDidMount() {
        var ctx = document.getElementById(this.props.id_graph);
        if (ctx === null) {
            ctx = this.props.new_window.document.getElementById(this.props.id_graph);
        }

        var local_max_x = 0;
        var local_min_x = 0;
        var curveDrawing = [];
        var curveThresholdDrawing = [];
        var currentTimeDrawing  = [];
        var annotations = {}

        if(this.props.curve !== undefined){
            local_max_x             = snapMaxToDayEnd(this.props.max_x);
            local_min_x             = snapMinToDayStart(this.props.min_x);
            curveDrawing            = this.props.curve;
            curveThresholdDrawing   = this.props.threshold || [];
            if((this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) || (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0)){
                annotations = this.generateAnnotationsList(annotations, this.props.alertPoints, this.props.alertPointsReminder, this.props.min)
            }
        }
        annotations = this.addMedianAnnotation(annotations)

        this.myChart = new Chart(ctx, {
            type: 'bar',
            data: {
                datasets: [
                    {
                        label: this.props.curve_name,
                        data: curveDrawing,
                        showLine: false,
                        fill: false,
                        backgroundColor: this.props.curve_color,
                        pointBorderWidth: 0,
                        pointRadius: 4
                    },
                    {
                        type: 'line',
                        label: this.props.threshold_name,
                        data: curveThresholdDrawing,
                        borderColor: this.props.threshold_color,
                        borderWidth: 0.5,
                        pointBackgroundColor: this.props.threshold_color,
                        showLine: true,
                        pointBorderWidth: 0,
                        pointRadius: 0
                    }
                ],
            },
            options: {
                parsing: false,
                normalized: true,
                responsive: true,
                animation: false,
                plugins: {
                    title: {
                        color: 'black',
                        font : {weight: 'bold'},
                        display: this.props.title !== undefined,
                        text: this.props.title
                    },
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: 'x',
                            threshold: 5,
                            modifierKey: 'shift',
                        },
                        limits: {
                          x: {min: 'original', max: 'original', minRange: 3600000},
                          y: {min: 'original', max: 'original'},
                        },
                        zoom: {
                          wheel: {
                            enabled: true,
                          },
                          pinch: {
                            enabled: true
                          },
                          drag: {
                            enabled: true,
                            backgroundColor: 'rgba(40, 150, 229, 0.15)',
                            borderColor: 'rgba(40, 150, 229, 0.8)',
                            borderWidth: 1,
                            threshold: 5,
                          },
                          mode: 'x',
                        }
                    },
                    annotation: {
                        annotations
                        },
                    tooltip: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                if (tooltipItem.dataset.label === "Usage") {                                    
                                    var mins = ((parseFloat(tooltipItem.formattedValue.replace(',', '.')).toFixed(2) + "").split(".")[1]);
                                    mins = mins / 100 * 60
                                    mins = mins.toFixed(0)
                                    if (mins.toString().length === 1) {
                                        mins = mins + "0";
                                    }
                                    let ret = tooltipItem.dataset.label + ": " + parseFloat(tooltipItem.formattedValue).toFixed(0) + "h" + mins + "m"
                                    if (tooltipItem.dataIndex !== 0) {
                                        if (tooltipItem.dataset.data[tooltipItem.dataIndex - 1].y !== tooltipItem.dataset.data[tooltipItem.dataIndex].y) {
                                            // Display the data variation
                                            let diff = (parseFloat(tooltipItem.dataset.data[tooltipItem.dataIndex].y) - parseFloat(tooltipItem.dataset.data[tooltipItem.dataIndex - 1].y)).toFixed(2);
                                            var hours = ((diff + "").split(".")[0]);
                                            var mins = ((diff + "").split(".")[1]);
                                            mins = mins / 100 * 60
                                            mins = mins.toFixed(0)
                                            if (mins.toString().length === 1) {
                                                mins = mins + "0";
                            }
                                            diff = hours + "h" + mins + "m"
                                            if (tooltipItem.dataset.data[tooltipItem.dataIndex - 1].y < tooltipItem.dataset.data[tooltipItem.dataIndex].y) {
                                    diff = '+' + diff
                                }
                                            ret += ' (' + diff + ')'
                            }
                        }
                                    return ret;
                                }
                                else {
                                    return tooltipItem.yLabel;
                                }
                            }
                    },
                        backgroundColor:'rgba(0,0,0,0.8)',  // black with transparency
                    },
                    legend: {
                        display: false
                    }
                },
                elements: {
                    point:{
                        hitRadius: 0
                    }
                },
                scales: {
                    x:
                    {
                        type: 'time',
                        min: local_min_x,
                        max: local_max_x,
                        distribution: 'series',
                        time: {
                            displayFormats: {
                                day: 'DD/MM',
                                month: 'DD/MM',
                            },
                            unit: 'day',
                            tooltipFormat: 'DD/MM'
                        },
                        ticks: {
                          // Only place ticks on real day boundaries (no extra tick
                          // at the exact min/max bounds) and let Chart.js thin them
                          // out, so DD/MM labels stay evenly spaced and don't pile
                          // up at the start of the axis (like the AHI / rate graphs).
                          source: 'auto',
                          includeBounds: false,
                          autoSkip: true,
                          // Wider gap + a hard cap so date labels stay clearly
                          // separated (no crowding around 25-32 day spans).
                          autoSkipPadding: 24,
                          maxTicksLimit: 8,
                          // Drop the leftmost date for 26-31 day ranges (it crowds the axis start).
                          callback: function(value, index, ticks) {
                            let ts = (ticks && ticks[index] && ticks[index].value !== undefined) ? ticks[index].value : value
                            let dayCount = Math.max(1, Math.ceil((this.max - this.min) / (24 * 3600000)))
                            if (index === 0 && dayCount >= 26 && dayCount <= 31) { return '' }
                            let d = new Date(ts)
                            let pad = (n) => ('0' + n).slice(-2)
                            return pad(d.getDate()) + '/' + pad(d.getMonth() + 1)
                          },
                          minRotation: 0,
                          maxRotation: 0,
                          major: {
                            enabled: true
                          },
                          font: function(context) {
                            if (context.tick && context.tick.major) {
                              return {
                                weight: 'bold',
                              };
                            }
                          }
                        }
                    },
                    y:
                    {
                        type: 'linear',
                        min: this.props.min,
                        max: this.props.max,
                        title: {
                            display: this.props.y_axis_title !== undefined,
                            text: this.props.y_axis_title,
                            color: this.props.curve_color                            
                        },
                        grid: {
                          drawOnChartArea: false,
                        },
                        ticks: {
                          color: this.props.curve_color, 
                          stepSize: 5
                        }                        
                    }
                },
            }
        });
    }

    updateData() {
        if((this.myChart !== undefined)&&(this.myChart.data !== undefined)){
            // Skip refresh while zoomed/panned so the periodic update does not
            // snap the view back to the full range. Resumes on reset.
            if(this.myChart.isZoomedOrPanned && this.myChart.isZoomedOrPanned()){ return; }
            this.myChart.options.scales.x.max  = snapMaxToDayEnd(this.props.max_x);
            this.myChart.options.scales.x.min  = snapMinToDayStart(this.props.min_x);
            this.myChart.data.datasets[0].data = this.props.curve;
            this.myChart.data.datasets[1].data = this.props.threshold || [];
            // Rebuild the annotations from scratch so alert points stay in sync
            // with the latest data (mutating the resolved options proxy recurses).
            let annotations = {}
            if((this.props.alertPoints !== undefined && this.props.alertPoints.length > 0) || (this.props.alertPointsReminder !== undefined && this.props.alertPointsReminder.length > 0)){
                annotations = this.generateAnnotationsList(annotations, this.props.alertPoints, this.props.alertPointsReminder, this.props.min)
            }
            annotations = this.addMedianAnnotation(annotations)
            this.myChart.options.plugins.annotation.annotations = annotations
            this.myChart.update();
        }
    }

    render() {
        return (
            <div className={classes.graphContainer} style={{display: "flex", flexDirection: "column", height: "100%", width: "100%"}}>
                <div style={{flex: "1 1 auto", minHeight: 0, width: "100%", display: "flex", justifyContent:'center', alignItems:'center'}}>
                    <canvas
                        style={{display: "flex", height: "100%", width: "100%", justifyContent:'center', alignItems:'center'}}
                        id={this.props.id_graph}
                        ref={this.chartRef}
                    />
                </div>
                <GraphZoomControls
                    getChart={() => this.myChart}
                    onEnlarge={this.props.onEnlarge}
                />
                {
                    this.updateData()
                }
            </div>
        )
    }
}
export default (GraphOneBar)
